export const iconFontAwesomeAccessibilityTty = (
	<i className="fa-solid fa-tty"></i>
);
